﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconAdjustmentsCog } from "@tabler/icons-react";


export const TiposServicioIcon = IconAdjustmentsCog;
export const TiposServicioHelpText = '* Aquí puede los diferentes tipos de servicio.';

export class catTiposServicio extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposServicio";
        this.def.columns.c_category_id.defaultValue = "TiposServicio";
        this.Title = "Tipos de Servicio";
        this.HelpText = TiposServicioHelpText;
        this.Icon = TiposServicioIcon;
    }
}